<template>
  <div>
    <div class="container-fluid container-boxed">
      <div class="card">
        <div class="card-header">
          <h2 class="card-header-title">Placement Completion</h2>
        </div><!-- /.card-header -->

        <ul class="list-data">
          <placement-completion-item v-for="placement in placement_completion" :placement="placement" :key="placement.id"/>
        </ul>
      </div><!-- /.card -->

      <div class="card">
        <div class="card-header">
          <h2 class="card-header-title">Capabilities Requiring Development</h2>
        </div>
        <ul class="list-data">
          <graduate-list-item v-for="graduate in graduates" :graduate="graduate" :key="graduate.id"/>

          <no-results v-if="haveNoGraduates">
            No graduates with capabilities requiring development found.
          </no-results>
        </ul><!-- /.list-data -->
      </div><!-- /.card -->

      <div class="card">
        <div class="card-header">
          <h2 class="card-header-title">Agencies</h2>
        </div><!-- /.card-header -->
        <ul class="list-data">
          <agency-list-item v-for="agency in agencies" :agency="agency" :key="agency.id"/>
        </ul><!-- /.list-data -->
      </div><!-- /.card -->
    </div><!-- /.container-fluid -->
  </div>
</template>

<script>
import { dashboardComputed, dashboardMethods } from 'vx/helpers'
import AgencyListItem from './DashboardAgencyItem'
import GraduateListItem from './DashboardUnderperformingGraduateItem'
import PlacementCompletionItem from './DashboardPlacementCompletionItem'
export default {
  components: {
    AgencyListItem,
    GraduateListItem,
    PlacementCompletionItem
  },

  computed: {
    ...dashboardComputed,

    haveNoGraduates () {
      return this.graduates.length === 0
    }
  },

  created () {
    this.getAgenciesOverview()
    this.getUnderperformingGraduates()
    this.getPlacementCompletion()
  },

  methods: {
    ...dashboardMethods
  }
}
</script>
